import { useBoolean } from '@dreryk/react-common';
import { ContentNode } from '@dreryk/react-components';

import { PurchasePackageModal } from './PurchasePackageModal';

type PurchasePackageModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type PurchasePackageModalOpenerProps = {
   readonly children: (renderProps: PurchasePackageModalOpenerRenderProps) => JSX.Element;
   readonly title: ContentNode;
};

export const PurchasePackageModalOpener = (props: PurchasePackageModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? <PurchasePackageModal onClose={closeModal} title={props.title} /> : null}
      </>
   );
};
